module.exports = __webpack_public_path__ + "img/company28.347dbb62.png";